import { render, staticRenderFns } from "./WeightListAdd.vue?vue&type=template&id=3e5a2b9a&scoped=true&"
import script from "./WeightListAdd.vue?vue&type=script&lang=js&"
export * from "./WeightListAdd.vue?vue&type=script&lang=js&"
import style0 from "./WeightListAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a2b9a",
  null
  
)

export default component.exports